import React from 'react'

function PresidentMessage() {
  return (
    <section id="about" className="about section">
    {/* Section Title */}
    <div className="container section-title" data-aos="fade-up">
      <h2 className='aboutus'>
        President Message
        <br />
      </h2>
      <p className='aboutpara' style={{ textAlign: 'justify' }}>
      *Message from the President of ACFE Oman* <br></br><br></br>

As the fight against fraud grows increasingly complex, ACFE Oman is committed to equipping its members with the knowledge, skills, and resources to combat fraud and promote integrity across both the public and private sectors. Our mission is to empower the next generation with the tools they need to contribute to Oman’s development goals by fostering a culture of fraud prevention.

Through training, Continuous Professional Education (CPE), and valuable networking opportunities, we raise awareness, promote ethical practices, and strengthen public understanding of fraud prevention. By engaging young professionals, we aim to build a more informed, responsible society and drive meaningful change that supports sustainable national growth.

Our leadership remains committed to enhancing the chapter’s role in raising public awareness and supporting fraud prevention best practices throughout Oman.<br></br><br></br>

Thank you for your ongoing dedication and passion!<br></br>

Sincerely,<br></br>

Haitham Humeid Al Raisi
President,<br></br> ACFE Oman
      </p>
    </div>
    {/* End Section Title */}
    <div className="container">
    <div className="row justify-content-center" data-aos="zoom-out">
    <div className="col-xl-7 col-lg-9 text-center" data-aos="fade-up" data-aos-delay={100}>
     
  <img 
    src="assets/img/ACFE/acfelogo.png" 
    alt="Description of the image" 
    style={{ 
      maxWidth: '100%', 
      height: 'auto',
      opacity: "40%" 
    }}
  />
</div>
<br/>
</div>
      
    </div>
  </section>
  )
}

export default PresidentMessage